import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9c66b42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center px-4 py-3 justify-between" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c9c66b42><circle cx=\"20\" cy=\"20\" r=\"20\" fill=\"#F5F7FE\" data-v-c9c66b42></circle><path d=\"M20 27.5V17.5\" stroke=\"#2C53F5\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-c9c66b42></path><path d=\"M26 27.5V11.5\" stroke=\"#2C53F5\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-c9c66b42></path><path d=\"M14 27.5V23.5\" stroke=\"#2C53F5\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-c9c66b42></path></svg>", 1)
const _hoisted_4 = { class: "flex flex-col ml-3" }
const _hoisted_5 = { class: "font-semibold uppercase" }
const _hoisted_6 = { class: "text-sm font-medium" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M18.4 14.1276V18.3996C18.4 18.824 18.2314 19.2309 17.9314 19.531C17.6313 19.831 17.2243 19.9996 16.8 19.9996H5.6C5.17565 19.9996 4.76869 19.831 4.46863 19.531C4.16857 19.2309 4 18.824 4 18.3996V7.19961C4 6.77526 4.16857 6.3683 4.46863 6.06824C4.76869 5.76818 5.17565 5.59961 5.6 5.59961H9.872",
  stroke: "#111520",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M16.7998 4L19.9998 7.2L11.9998 15.2H8.7998V12L16.7998 4Z",
  stroke: "#111520",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11 13.1113H12.5556H25",
  stroke: "#111520",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.889 13.1111V11.5556C14.889 11.143 15.0529 10.7473 15.3446 10.4556C15.6363 10.1639 16.032 10 16.4446 10H19.5557C19.9682 10 20.3639 10.1639 20.6556 10.4556C20.9473 10.7473 21.1112 11.143 21.1112 11.5556V13.1111M23.4446 13.1111V24C23.4446 24.4126 23.2807 24.8082 22.9889 25.0999C22.6972 25.3917 22.3016 25.5556 21.889 25.5556H14.1112C13.6987 25.5556 13.303 25.3917 13.0113 25.0999C12.7196 24.8082 12.5557 24.4126 12.5557 24V13.1111H23.4446Z",
  stroke: "#111520",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6 9.5L11.5 15L17 9.5",
  stroke: "#111520",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none p-4"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Загрузка данных...", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении данных произошла ошибка", -1))
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 1,
  class: "grid grid-cols-5 gap-4 p-4"
}
const _hoisted_21 = { class: "flex flex-col justify-between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Секторы", -1))
const _hoisted_23 = { class: "text-sm mt-2" }
const _hoisted_24 = { class: "flex flex-col justify-between" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Накладные", -1))
const _hoisted_26 = { class: "font-medium text-sm mt-2" }
const _hoisted_27 = { class: "flex flex-col justify-between" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Стопы", -1))
const _hoisted_29 = { class: "font-medium text-sm mt-2" }
const _hoisted_30 = { class: "flex flex-col justify-between" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Физ. вес", -1))
const _hoisted_32 = { class: "font-medium text-sm mt-2" }
const _hoisted_33 = { class: "flex flex-col justify-between" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Об. вес", -1))
const _hoisted_35 = { class: "font-medium text-sm mt-2" }
const _hoisted_36 = {
  key: 2,
  class: "border-t border-gray-200 p-4"
}
const _hoisted_37 = { class: "ForecastingWave__filters" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_39 = {
  class: "max-w-full overflow-hidden overflow-x-auto",
  style: {"padding-bottom":"16px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_wave_invoice_table_row = _resolveComponent("wave-invoice-table-row")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ForecastingWave", { 'border border-blue-500': _ctx.state.is_expanded }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.wave.title), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatDateFromBackend(_ctx.wave.date)) + ", " + _toDisplayString(_ctx.wave.fromTime) + " - " + _toDisplayString(_ctx.wave.toTime), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isCanUpdate)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 0,
              class: "cursor-pointer",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onUpdateWave && _ctx.onUpdateWave(...args)))
            }, _hoisted_10))
          : _createCommentVNode("", true),
        (_ctx.isCanDelete)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 1,
              class: "cursor-pointer ml-6",
              width: "36",
              height: "36",
              viewBox: "0 0 36 36",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDeleteWave && _ctx.onDeleteWave(...args)))
            }, _hoisted_13))
          : _createCommentVNode("", true),
        (_openBlock(), _createElementBlock("svg", {
          class: "cursor-pointer ml-6",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleComponent && _ctx.toggleComponent(...args)))
        }, _hoisted_15))
      ])
    ]),
    (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_17
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_18,
                  _createVNode(_component_new_button, {
                    class: "mt-1",
                    onClick: _ctx.loadWaveData
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (!_ctx.state.data)
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Нет данных"))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (Boolean(_ctx.state.data))
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              (!_ctx.state.data.sectors.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" - ")
                  ], 64))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.data.sectors, (sector, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "font-medium",
                  key: sector.id
                }, [
                  (i === 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(sector.name), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(", " + _toDisplayString(sector.name), 1)
                      ], 64))
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.state.data.invoicesCount), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.state.data.stopsCount), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.state.data.weight), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.state.data.volumeWeight), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (Boolean(_ctx.state.data) && _ctx.state.is_expanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_new_select, {
              placeholder: "Сектор",
              class: "NewSelect--xs",
              value: _ctx.state.filters.sectorId,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.filters.sectorId) = $event)),
              "search-without-refresh": "",
              "error-text": "При получении списка секторов произошла ошибка",
              disabled: _ctx.state.is_loading,
              loading: _ctx.data_state.sectors.is_loading,
              failed: _ctx.data_state.sectors.is_failed,
              options: _ctx.data_state.sectors.list,
              onRefresh: _ctx.loadSectors,
              onChange: _ctx.loadWaveData
            }, null, 8, ["value", "disabled", "loading", "failed", "options", "onRefresh", "onChange"]),
            _createVNode(_component_new_select, {
              placeholder: "Доп услуга",
              class: "NewSelect--xs",
              value: _ctx.state.filters.additionalServices,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.filters.additionalServices) = $event)),
              "search-without-refresh": "",
              multiselect: "",
              "error-text": "При получении списка доп. услуг произошла ошибка",
              disabled: _ctx.state.is_loading,
              loading: _ctx.data_state.additional_services.is_loading,
              failed: _ctx.data_state.additional_services.is_failed,
              options: _ctx.data_state.additional_services.list,
              onRefresh: _ctx.loadAdditionalServices,
              onChange: _ctx.loadWaveData
            }, null, 8, ["value", "disabled", "loading", "failed", "options", "onRefresh", "onChange"]),
            _createVNode(_component_new_select, {
              placeholder: "Статус груза",
              class: "NewSelect--xs",
              value: _ctx.state.filters.statusId,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.filters.statusId) = $event)),
              searchable: false,
              disabled: _ctx.state.is_loading,
              options: _ctx.CARGO_STATUSES,
              onChange: _ctx.loadWaveData
            }, null, 8, ["value", "disabled", "options", "onChange"]),
            _createVNode(_component_new_button, {
              disabled: _ctx.state.is_loading,
              class: "NewButton--reset NewButton--xs",
              onClick: _ctx.onResetFilters
            }, {
              default: _withCtx(() => [
                _hoisted_38,
                _createTextVNode(" СБРОС ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_new_table, {
              small: "",
              "clickable-rows": "",
              "select-indexes": [],
              "select-class": "bg-red-100",
              columns: _ctx.TABLE_COLUMNS,
              rows: _ctx.state.data.invoices,
              onRowClick: _ctx.onRowClicked
            }, {
              td: _withCtx(({ column, row, index }) => [
                _createVNode(_component_wave_invoice_table_row, {
                  column: column,
                  row: row,
                  index: index + 1
                }, null, 8, ["column", "row", "index"])
              ]),
              _: 1
            }, 8, ["columns", "rows", "onRowClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}